define('companiesMainRouter',[
  'require',
  'exports',
  'module',
  'underscore',
  'marionette',
  'app',
  'itemPagesNameMixin',
  'entities/companies/companies'
], function (
  require,
  exports,
  module,
  _,
  Marionette,
  App,
  ItemPagesNameMixin
) {
  'use strict';

  var CompaniesRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'companies': 'showList',
      'companies(/:id)(/:tab)': 'showDetail'
    }
  });

  var API = {
    showList: function () {
      require([
        'companiesListController',
        'contentShowController'
      ], function (ListController, ContentShowController) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          ListController.showCompaniesList();
          App.execute('set:active:nav:item', ItemPagesNameMixin.COMPANIES);
        });
      });
    },

    showDetail: function (id, tabName) {
      require([
        'companiesDetailView',
        'contentShowController'
      ], function (View, ContentShowController) {
        var model = App.request('companies:entity', id);
        model.fetch().done(function () {
          var view = new View({
            model: model,
            tabName: tabName ? tabName : 'subaccounts'
          });

          ContentShowController.showContent().done(function () {
            App.currentUrl = App.getCurrentRoute();
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
            App.execute('set:active:nav:item', ItemPagesNameMixin.COMPANIES);
          });
        });
      });
    }
  };

  App.on('companies:show', function (id, tabName) {
    App.navigate('companies/' + id + '/' + (tabName ? tabName : 'subaccounts'), {trigger: true});
  });

  App.on('before:start', function () {
    new CompaniesRouter({
      controller: API
    });
  });

  module.exports = CompaniesRouter;
});

